import { PreferencesLoadingErrorModal } from 'components/Blotters/Quotes/preferencesLoadingErrorModal';
import { QuotesBlotter } from 'components/Blotters/Quotes/quotes-blotter';
import { CentralStation } from 'components/CentralStation/CentralStation';
import { useAppSelector } from 'hooks/useAppSelector';
import { useReponsiveBreakpoints } from 'hooks/useOnWindowResize';
import { FC } from 'react';
import { isOrdersBasketEnabled } from 'state/selectors/common/userFeatures';

const QuotesBlotterRouteComponent: FC = () => {
  const { xl } = useReponsiveBreakpoints();
  const isOrdersBasket = useAppSelector(isOrdersBasketEnabled);
  return (
    <div className="quotes-blotter-route-component page-container w-100 h-100">
      <PreferencesLoadingErrorModal>
        {isOrdersBasket && xl ? <CentralStation /> : <QuotesBlotter />}
      </PreferencesLoadingErrorModal>
    </div>
  );
};

export default QuotesBlotterRouteComponent;
